import React, { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import Avatar from '@justgiving/avatar';
import classNames from 'classnames';

import parseCurrency from '../../utils/parseCurrency';
import TimestampWrapper from '../TimestampWrapper/TimestampWrapper';
import UserListItem from '../UserListItem/UserListItem';
import styles from './SupporterDetails.scss';

export type SupporterDetailsProps = {
  image?: string;
  date?: string;
  donationAmount?: number | null;
  currencyCode?: string;
  giftAidAmount?: number;
  userName: string | ReactNode | null;
  message: string | ReactNode;
};

class SupporterDetails extends React.PureComponent<SupporterDetailsProps> {
  render() {
    const {
      image,
      date,
      donationAmount,
      currencyCode,
      giftAidAmount,
      userName,
      message,
    } = this.props;

    return (
      <UserListItem
        picture={<Avatar avatarSize="auto" picture={image} />}
        alignTop
      >
        <h2 className="jg-h5" data-qa="supporter-title">
          {userName || <Trans i18nKey="common.anonymous" />}
          {date && (
            <span
              className={classNames('jg-pull-right', 'jg-text--small-light')}
            >
              <TimestampWrapper date={date} />
            </span>
          )}
        </h2>
        <p className={`jg-text--medium-light', ${styles.donationMessage}`}>
          {message}
        </p>
        {typeof donationAmount === 'number' &&
          donationAmount > 0 &&
          currencyCode && (
            <p
              className={classNames('jg-text--brand', 'jg-text-color-branded')}
              data-qa="donation-amount"
            >
              {parseCurrency(currencyCode, donationAmount)}
              {typeof giftAidAmount === 'number' && giftAidAmount > 0 && (
                <span
                  className={classNames(
                    'jg-text--brand-small',
                    'jg-text-color-branded',
                  )}
                >
                  {` + `}
                  {parseCurrency(currencyCode, giftAidAmount)}{' '}
                  <Trans i18nKey="common.giftaid" />
                </span>
              )}
            </p>
          )}
      </UserListItem>
    );
  }
}

export default SupporterDetails;
